.container {
	width: 100%;
	height: 100%;
	background-color: var(--depth0);
	padding: 2rem !important;
	display: flex;
	flex-direction: row-reverse;
	justify-content: space-around;
	gap: 5px;
}

.activateForm h1 {
	font-size: 2vw;
}
.loadingCircle {
	height: 100px;
	width: 100px;
	position: absolute;
	margin: auto;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	border-radius: 100%;
	overflow: hidden;
	background-color: var(--depth0);
}
.loadingCircle:before {
	content: '';
	background-image: conic-gradient(var(--blue) 40deg, var(--depth0));
	height: 150%;
	width: 150%;
	position: absolute;
	left: -25%;
	top: -25%;
	animation: rotate 2s infinite linear;
}
@keyframes rotate {
	100% {
		transform: rotate(-360deg);
	}
}
.loadingCircle:after {
	content: '';
	height: 70%;
	width: 70%;
	position: absolute;
	background-color: var(--depth0);
	border-radius: 100%;
	top: 15%;
	left: 15%;
	color: #04b0ee;
	display: grid;
	place-items: center;
	font-size: 20px;
	letter-spacing: 6px;
}
.container h1 {
	text-align: center;
	font-size: 2rem;
}
